import TextSnippetWrapper from './TextSnippetWrapper';

export default TextSnippetWrapper;
